import * as React from "react";
import { Button } from "@authe/ui-core";
import { QuickStartCard, QuickStartActionCard } from "./QuickStartCard";
import { useQuickStart, useQuickStartMinimized } from "./useQuickStart";
import { AutomaticDefaults } from "@/features/settings/AutomaticDefaults";

export function QuickStart(): React.ReactElement {
  const model = useQuickStart();
  const [minimized, setMinimized] = useQuickStartMinimized();
  return <QuickStartCard model={model} showGuideLink minimized={minimized} onMinimizedChange={setMinimized} />;
}

export interface GettingStartedProps { onDismiss?: () => void }

export function GettingStarted({ onDismiss }: GettingStartedProps): React.ReactElement {
  const model = useQuickStart();
  const recommended = new Set(model.recommended.map(action => action.id));
  const options = model.all.filter(action => !recommended.has(action.id));
  return <div className="space-y-6">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="max-w-2xl">
        <h1 className="text-2xl font-semibold tracking-tight">Get started with Authe</h1>
        <p className="mt-1 text-sm text-muted-foreground">Choose what you want to do. These suggestions reflect your plan, access and workspace activity; they are not required setup steps.</p>
      </div>
      {onDismiss && <Button variant="outline" onClick={onDismiss}>Go to your queue</Button>}
    </div>
    <AutomaticDefaults />
    <QuickStartCard model={model} />
    {options.length > 0 && <section aria-labelledby="workspace-options">
      <h2 id="workspace-options" className="mb-3 text-lg font-semibold">When you need more</h2>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
        {options.map(action => <QuickStartActionCard key={action.id} action={action} />)}
      </div>
    </section>}
  </div>;
}
